import axios from 'axios';
import tokenStorage from '../../helpers/tokenStorage';

const { VUE_APP_BASE_URL } = process.env;

// To not include the interceptors
const axiosWithoutInterceptors = axios.create({
  baseURL: VUE_APP_BASE_URL
});

export const fetchToken = (body) => {
  const data = {
    username: body.username,
    password: body.password,
    grant_type: 'password',
    scope: 'ocean'
  };

  return axiosWithoutInterceptors({
    method: 'POST',
    url: '/oauth/token',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    data
  });
};

export const refreshToken = () => {
  const token = tokenStorage.get();

  const data = {
    grant_type: 'refresh_token',
    scope: 'ocean',
    refresh_token: token.refresh_token
  };

  return axiosWithoutInterceptors({
    method: 'POST',
    url: '/oauth/token',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    data
  });
};

export const revokeToken = () => {
  const token = tokenStorage.get();

  const data = {
    token: token.access_token
  };

  return axiosWithoutInterceptors({
    method: 'POST',
    url: '/oauth/revoke',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    data
  });
};

export default {
  fetchToken,
  refreshToken,
  revokeToken
};
